import React, { Dispatch, SetStateAction } from 'react';

import { Box, Divider, Drawer, Stack, Typography } from '@mui/material';

import { FlexCol, FlexRow } from '../../../../common/components/v2';
import { Decision } from '../../../../common/constants/decision';
import { Reason } from '../../../../common/constants/reasons';
import { Resource } from '../../../../common/constants/resource';
import { Metadata } from '../../../../common/dataTypes';
import { IDecision } from '../../interfaces/IDecision';
import DrawerHeader from '../DrawerHeader';
import styles from '../styles.module.scss';
import DeclineForm from './DeclineForm';
import { DeclineFormData } from './useDeclineForm';

export const EditDecline = ({
  isOpen,
  setIsOpen,
  coverage,
  term,
  rateClass,
  tobaccoClass,
  declineConditions,
  isUpdate,
  isPIA,
  reasons,
  onSuccess,
  initialFormData,
  onDecisionChanged,
  editedDecision,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  coverage: number;
  term: number;
  rateClass: string;
  tobaccoClass: string;
  declineConditions: Metadata[];
  isUpdate: boolean;
  isPIA: boolean;
  reasons: Reason[];
  onSuccess: (formData: DeclineFormData) => void;
  initialFormData?: DeclineFormData | null;
  onDecisionChanged?: (decision: Decision) => void;
  editedDecision?: IDecision;
}) => (
  <Drawer
    open={isOpen}
    anchor="right"
    variant="persistent"
    classes={{ paper: styles.Drawer }}
    transitionDuration={{ enter: 0, exit: 0 }}
  >
    <DrawerHeader
      title={
        isUpdate
          ? Resource.UPDATE_DECISION_HEADER
          : Resource.DECLINE_APPLICATION_HEADER
      }
      onClose={() => setIsOpen(false)}
    />
    <Divider />
    <Box m={3}>
      <FlexRow>
        <FlexCol xs={12}>
          <Typography variant="caption">Applied for</Typography>
        </FlexCol>
      </FlexRow>
      <Stack mt={2} direction="row" spacing={4}>
        <Stack spacing={1}>
          <Typography variant="body2">Max Coverage</Typography>
          <Typography variant="body2">Term Length</Typography>
          <Typography variant="body2">Class</Typography>
          <Typography variant="body2">Tobacco</Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="body1">
            {coverage != null ? `$${coverage.toLocaleString()}` : '—'}
          </Typography>
          <Typography variant="body1">{term}</Typography>
          <Typography variant="body1">{rateClass}</Typography>
          <Typography variant="body1">{tobaccoClass}</Typography>
        </Stack>
      </Stack>
    </Box>
    <Divider />
    <Box m={3}>
      <DeclineForm
        onDecisionChanged={onDecisionChanged}
        initialFormData={initialFormData}
        isOpen={isOpen}
        declineConditions={declineConditions}
        reasons={reasons}
        isPIA={isPIA}
        onSuccess={onSuccess}
        isUpdate={isUpdate}
        editedDecision={editedDecision}
      />
    </Box>
  </Drawer>
);
